module.exports = __webpack_public_path__ + "images/08-08@2x_12fcf2c5.png";